import React, { useEffect, useState, useRef } from 'react';
import Modal from "../../../component/Global/Modal";
import Common from "../../../component/Global/Cart/Common";
import BOM from "@system/config/bom";
import PriceTable from 'src/component/Global/Cart/PriceTable';
import DisplayQtyMinQtyMult from 'src/component/Product/DisplayQtyMinQtyMult';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import ProductInventoryRepository from "../../../repository/ProductInventoryRepository";
import ProductPricingRepository from "../../../repository/ProductPricingRepository";
import ProductListing from "../../../model/ProductListing";
import BOMRepository from 'src/repository/BOMRepository';
import Helper from 'src/support/Helper';
import store from 'src/storeWire';
import { SET_bomMultipleMatchTrigger } from 'src/store/slice/model/BOM';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/support/Constants';
import liveAuth from 'src/helper/liveAuth';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { useBOMProjectStore } from "src/hooks/bom_project";

const BomSearchMatchPopup = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [status, SetStatus] = useState(false);
  const [productData, setProductData] = useState([]);
  const [multipleSearchData, setMultipleSearchData] = useState([]);
  const [{ BomSearchMatchPopup }, { }, { }] = useDOMAttachToSystemStore();
  const modalRef = useRef(null);
  const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type }, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { swap_part_number },] = useBOMStore();

  const currentBom = BomSearchMatchPopup?.data && BomSearchMatchPopup.data.single_bom;
  const [{ CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
  const [_check_p] = useCheckAuthPermissions();

  const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
  const [{ pricingList }, { }, { }] = useProductPricingStore();

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onHide();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    async function fetchHere() {
      if (BomSearchMatchPopup) {
        await getProductData();
        SetStatus(true);
      }
    }

    fetchHere();
  }, [BomSearchMatchPopup]);

  const onHide = (action = true) => {
    SetStatus(false);
  };

  const getProductData = async () => {
    let res = await new BOMRepository().getMultipleMatchProductSearch(currentBom.bomDetailId);
    setMultipleSearchData(res);
    let inventory = {};
    let pricing = {};

    // Auth Account Less User Restrict Pricing call
    if (validateNonLoginUser()) {
      inventory =
        await new ProductInventoryRepository().fetchProductInventoryByProducts(
          res.Products
        );
    } else {
      await Promise.all([
        new ProductInventoryRepository().fetchProductInventoryByProducts(
          res.Products
        ),
        new ProductPricingRepository().fetchProductPricingByProductsNew(
          res.Products,
          true
        ),
      ]).then((resp) => {
        inventory = resp[0];
        pricing = resp[1];
      })
        .catch(() => { });
    }

    let finalRes =
      new ProductListing().attachInventoryAndPricingToProductObjectNew(
        res.Products,
        {
          inventory,
          pricing,
        }
      );

    setProductData(finalRes);
  };

  const onSwapHandler = async (
    erpPartNumber,
    quantity,
    LifeCycleRisk = "-",
    ManufacturerPartNumber = false,
    ItemNumber = false,
    customerPartNumber,
    ERPMFRPartNumber = "",
    selectedProdData
  ) => {
    let params = {};
    params.partNumber = ERPMFRPartNumber;
    params.itemNumber = ItemNumber;
    params.erpPartNumber = erpPartNumber;
    params.manufacturerPartNumber = ERPMFRPartNumber;
    params.quantity = quantity;
    params.LifeCycleRisk = LifeCycleRisk ? LifeCycleRisk : "";
    params.bomDetailId = currentBom.bomDetailId;
    params.bomId = currentBom.bomId;
    params.customerPartNumber = customerPartNumber;
    params.manualCPN = currentBom.customerPartNumber ? currentBom.customerPartNumber : "";
    params.designWinFlag = currentBom?.designWinFlag;
    params.cpnType = Common.isCpnIsManual(selectedProdData, customerPartNumber) ? Constants.cpnTypes.MANUALCPN : Constants.cpnTypes.CPN

    let swapPartRes = await swap_part_number(params);
    if (swapPartRes?.payload?.data !== undefined) {
      multipleMatchesEvent(selectedProdData);
      await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(params.bomId);
      onHide();
      store.dispatch(
        SET_bomMultipleMatchTrigger({
          BOMTriggerVal: "BOM_EXACT_TRIGGER",
        })
      );
    }
  };

  //By Ramya Kannan [BOM MUltiple matches - Adobe script ]
  const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
  function multipleMatchesEvent(selectedProdData) {
    localStorage.setItem("adobeEventType", "bomProdSelectionMultipleResolved");
    let bomDetails = {
      bomId: bom_detail_by_bom_id.bomId || dwdDetails.bomId,
      bomName: bom_detail_by_bom_id.bomName,
      newBOM: bom_detail_by_bom_id.newBOM,
      source: bom_detail_by_bom_id.source,
      exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
      nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
      multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
    };
    if (bom_project_list) {
      bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
    }

    let prodDetails = selectedProdData;
    prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
    let pricingDetails = getPricing(
      prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
      prodDetails.ERPPartNumber,
      prodDetails.ERPPartNumberModified
    )[0];
    prodDetails.priceSource = pricingDetails?.priceSource;
    prodDetails.subtotal = pricingDetails?.marketPrice ? pricingDetails.marketPrice * 1000 : 0;

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({
        prodDetails,
        bomDetails,
      });
    }
  }

  const getInventory = (ERPPartNumber) => {
    return get_inventory_by_id(ERPPartNumber)
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    console.log(pricingList);
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

  const displayMarketPrice = (pricing_single_display) => {
    let marketValue =
      pricing_single_display && pricing_single_display.marketPrice
        ? Helper.getFormatNumber(
          Number(pricing_single_display.marketPrice),
          window.mct,
          window.mcs,
          5
        )
        : "";
    return marketValue;
  };

  const isGuestFullRights = () => {
    return _check_p("PDG_ADD_TO_CART").status &&
        _check_p("PDG_ADD_TO_BOM").status &&
        _check_p("PDG_CLICK_TO_QUOTE").status;
  };

  const validateNonLoginUser = () => {
    if (!liveAuth.check()) {
      return true;
    }
    if (liveAuth.check() && !isGuestFullRights()) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Modal show={status} onHide={() => { onHide(); }}      >
        <div ref={modalRef} className="avnet-modal avnet-modal-right modal-630">
          <div className="avnet-modal-inner">
            <button
              type="button"
              className="close py-3"
              data-dismiss="modal"
              onClick={() => {
                onHide();
              }}
            >
              ×
            </button>
            <div className="modal-header">
              <h4 className="modal-title text-center" id="myModalLabel">
                SEARCH MATCH
              </h4>
            </div>
            <div className="modal-body">
              <div className="alert alert-info">
                <span>
                  You searched for {currentBom && currentBom.partNumberRaw},
                  there are {multipleSearchData && multipleSearchData.Count}{" "}
                  possible matches:
                </span>
              </div>
              <div className="search-match-wrapper">
                {productData && Object.keys(productData).length > 0 &&
                  Object.entries(productData).map((v) => (
                    <div key={v} className="search-match-item">
                      <div className="search-match-text mb-3">
                        <b>{v[1].ERPMFRPartNumber}</b>
                        <span>
                          {" "}
                          {v[1].ManufacturerName
                            ? "by " + v[1].ManufacturerName
                            : ""}
                        </span>
                        <div>{v[1].ShortDescription}</div>
                      </div>
                      <div className="bs5 row">
                        <div className="col-4">
                          <div className="price-table-list price-table-list-with-border">
                            {v[1].assets.pricing && v[1].assets.pricing.length > 0 && (
                              <div className="bs5 row m-0 font_bold_currency border-0 mb-2">
                                <div className="col-8">
                                  <span className="font-24">
                                    {displayMarketPrice(
                                      v[1].assets.pricing[0]
                                    )}
                                  </span>
                                </div>
                                <div className="col-4 text-end align-self-end">
                                  <span className="font-13 text-black-stone font-normal">
                                    (
                                    {window.mct === window.mcs
                                      ? window.mct
                                      : window.mct + "" + window.mcs}
                                    )
                                  </span>
                                </div>
                              </div>
                            )}

                            <PriceTable
                              force_display_pricing_table={"yes"}
                              single_product_pricing_list={v[1].assets.pricing}
                              single_product_inventory={v[1].assets.inventory}
                              single_product={v[1]}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div>
                            <div className="text-darkgreen  d-flex align-items-center">
                              <i className="fa fa-check-circle me-1"></i>
                              <span className="d-flex text-darkgreen w-100">
                                <b>In Stock</b>
                                <b className="ms-auto">
                                  {" "}
                                  {v[1].assets.inventory.quantity}{" "}
                                </b>
                              </span>
                            </div>
                            <div
                              id="availability_cont_3_lead_time"
                              className="grey"
                            >
                              <div className="addtn-inventory leadTime">
                                <strong>ADDITIONAL INVENTORY</strong>
                                <div className="clearfix">
                                  <FactoryLeadTimeDisplay
                                    single_product={v[1]}
                                    single_product_inventory={
                                      v[1].assets.inventory
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="prod-option-icon sect-2">
                              <div className="bs5 d-flex flex-wrap">
                                <ProductLegends
                                  single_product={v[1]}
                                  onlyIcon={true}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-4 align-self-end">
                          {__check(["BOM_SWAP_PART_NUMBER_API_CALL"], { inline: true, }).render}
                          {!__check(["BOM_SWAP_PART_NUMBER_API_CALL"]).status && (
                            <>
                              <DisplayQtyMinQtyMult single_product={v[1]} />
                              <button
                                className="bs5 btn btn-primary w-100"
                                onClick={() =>
                                  onSwapHandler(
                                    v[1].ERPPartNumber,
                                    v[1].QtyMin,
                                    v[1].LifeCycleRisk,
                                    v[1].ManufacturerPartNumber,
                                    v[1].ItemNumber,
                                    CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[v[1].ItemNumber]?.CUSTOMER_PART_NUMBER,
                                    v[1].ERPMFRPartNumber,
                                    v[1]
                                  )
                                }
                              >
                                Select
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              {multipleSearchData && multipleSearchData.Count > 10 && (
                <a className="see-all-results text-blue2"
                  onClick={() => {
                    window.location.href = BOM.getBomProductListingRouteURL(
                      currentBom.bomId,
                      {
                        bomDetailId: currentBom.bomDetailId,
                        search: multipleSearchData && multipleSearchData.PartailSearch,
                        searchColumn: multipleSearchData?.BomSearchColumns &&
                          btoa(JSON.stringify(multipleSearchData.BomSearchColumns)),
                      }
                    );
                  }}
                >
                  See all {multipleSearchData && multipleSearchData.Count}{" "}
                  results
                </a>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default BomSearchMatchPopup;